import { AlertTriangle } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface Props {
  loaded: number
  total?: number | null
  limit: number
}

export function TruncationWarning({ loaded, total, limit }: Props) {
  const { t } = useTranslation('common')
  const isTruncated = total != null ? loaded < total : loaded >= limit

  if (!isTruncated) return null

  return (
    <div className="flex items-center gap-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-xs font-medium text-amber-900 dark:border-amber-900/60 dark:bg-amber-950/40 dark:text-amber-300">
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
      <span>
        {total != null
          ? t('truncation.with_total', {
              loaded,
              total,
              defaultValue: '{{loaded}} sur {{total}} résultats affichés — affinez votre recherche pour voir les autres.',
            })
          : t('truncation.at_limit', {
              limit,
              defaultValue: '{{limit}} premiers résultats affichés — affinez votre recherche pour voir les autres.',
            })}
      </span>
    </div>
  )
}
